/* Kleurfamilie: haalt de kleuren van hetzelfde model live op uit Shopify (tag group_title) en toont alleen kleuren met voorraad,
   plus de kleur van de bekeken pagina (die blijft altijd staan, net als het kleurlabel). Lukt het ophalen niet,
   dan blijft het bestaande kleurblok staan. */
(function () {
  function vul(box) {
    var url = box.getAttribute('data-url');
    var huidig = box.getAttribute('data-current');
    if (!url || !huidig) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = Array.prototype.slice.call(doc.querySelectorAll('[data-kleurfamilie-items] .product-from-same-group__item'));
        var houden = items.filter(function (i) {
          return i.getAttribute('data-available') === 'true' || i.getAttribute('data-handle') === huidig;
        });
        if (!houden.some(function (i) { return i.getAttribute('data-handle') === huidig; })) return;
        var blok = box.querySelector('.product-info__group');
        if (!blok && houden.length < 2) return;
        if (!blok) {
          var leeg = box.querySelector('template[data-kleurfamilie-leeg]');
          if (!leeg) return;
          blok = leeg.content.querySelector('.product-info__group').cloneNode(true);
          box.insertBefore(blok, leeg);
        }
        var wrapper = blok.querySelector('.swiper-wrapper');
        if (!wrapper) return;
        wrapper.innerHTML = '';
        houden.forEach(function (i) {
          var a = i.querySelector('a');
          if (a && i.getAttribute('data-handle') === huidig) a.classList.add('product-from-same-group__button--active');
          wrapper.appendChild(document.importNode(i, true));
        });
        var slider = blok.querySelector('swiper-slider');
        if (slider && slider.swiper && typeof slider.swiper.update === 'function') {
          slider.swiper.update();
          if (slider.swiper.navigation && typeof slider.swiper.navigation.update === 'function') slider.swiper.navigation.update();
        }
      })
      .catch(function () {});
  }
  function start() { document.querySelectorAll('[data-kleurfamilie]').forEach(vul); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
